import { colors } from "../../data/colors";
import { stdObject } from "../../data/types/stdObject";
import BasicButton from "../BasicButton";
import MiniatureFile from "../DocumentModal/components/MiniatureFile";
import RefreshIcon from "@mui/icons-material/Refresh";
import useFilesManager from "./useFilesManager";

export default function FilesManager({
  init,
  filesButtons,
  updateRoot,
  mainColor,
  level = 1,
}: stdObject) {
  const {
    t,
    folder,
    setFolder,
    filesList,
    fileInputRef,
    startUploading,
    handleFile,
    refreshFiles,
    handleButtonClick,
  } = useFilesManager({ init, filesButtons, updateRoot, level });

  return (
    <>
      <div
        className="wrapBox"
        style={{
          backgroundColor: colors.lightGrey2,
          overflow: "auto",
          //  ...style,
        }}
      >
        <table align="center">
          <tbody>
            <tr>
              {Array.isArray(filesButtons) &&
                filesButtons.map((e: stdObject, index: number) => (
                  <td key={index}>
                    <BasicButton
                      onClick={() => setFolder(e.type)}
                      title={t(e.label)}
                      color={folder === e.type ? mainColor : colors.darkGrey}
                    />
                  </td>
                ))}
              <td>
                <BasicButton
                  Icon={RefreshIcon}
                  onClick={refreshFiles}
                  title={t("p.refresh")}
                  color={colors.orange}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="docInfoContent">
        <div className="wrapBox">
          <MiniatureFile
            name={t("p.addFile")}
            add={true}
            onClick={handleButtonClick}
          />
          {folder in filesList &&
            filesList[folder].list.map((e: string, index: number) => (
              <MiniatureFile
                key={index}
                name={e}
                add={false}
                onClick={() => handleFile(e)}
              />
            ))}
        </div>
      </div>
      <div
        style={{
          backgroundColor: colors.lightGrey,
          padding: 10,
          borderTop: `solid 1px ${colors.darkGrey}`,
          display: "flex",
          flexDirection: "row",
        }}
      >
        {t("p.quantity")}:{" "}
        {folder in filesList ? filesList[folder].list.length : 0}
      </div>
      <input
        type="file"
        ref={fileInputRef}
        onChange={startUploading}
        style={{ display: "none" }}
      />
    </>
  );
}
